export const robot = {
  activateStatus: [
    {
      value: -1,
      label: '试用'
    }, {
      value: 1,
      label: '未激活'
    }, {
      value: 2,
      label: '已激活'
    }, {
      value: 3,
      label: '失效'
    }, {
      value: 4,
      label: '待转移'
    }
    // {
    //   value: 5,
    //   label: '已合并'
    // }, {
    //   value: 6,
    //   label: '已分配给下游企业'
    // }
  ],
  activateType: [
    {
      value: 1,
      label: '基础账号'
    }, {
      value: 2,
      label: '互通账号'
    }
  ],
  // 接单流程 flowType 码表
  flowType: [{
    value: 10,
    label: '接单话术'
  }, {
    value: 13,
    label: '接单失败'
  }, {
    value: 16,
    label: '报价失败提示'
  }, {
    value: 18,
    label: '未获取到报价险种提示'
  }, {
    value: 20,
    label: '报价单提示'
  }, {
    value: 30,
    label: '支付提醒'
  }, {
    value: 40,
    label: '发送电子保单'
  }, {
    value: 25,
    label: '重复投保提示'
  }, {
    value: 50,
    label: '验车码'
  }, {
    value: 17,
    label: '未匹配报价单提示'
  }, {
    value: 49,
    label: '电子保单失败提示'
  }, {
    value: 900,
    label: '识别到投保需求'
  }, {
    value: 1100,
    label: '准备报价'
  }, {
    value: 999,
    label: '轻客服'
  }]
}

export default {
  robot
}



// WEBPACK FOOTER //
// ./src/data/robot.js